import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import VideoCard from '../media/VideoCard';
import PageHeader from './PageHeader';
import { api } from '../../lib/api';
import { SITE_URL } from '../../lib/seo';

export default function Media() {
  const { t } = useTranslation();
  const [videos, setVideos] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    api
      .listVideos()
      .then((data) => {
        if (active) setVideos(data.videos || []);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
    };
  }, []);

  // VideoObject structured data only for entries with the fields schema.org
  // requires (thumbnailUrl, uploadDate) — never emitted with guessed or
  // missing values.
  const videoJsonLd = (videos || [])
    .filter((v) => v.posterUrl && v.publishedAt)
    .map((v) => ({
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: v.title,
      description: v.description || v.title,
      thumbnailUrl: [v.posterUrl],
      uploadDate: v.publishedAt,
      embedUrl: v.url
    }));

  return (
    <Box>
      <Helmet>
        <title>Videos | Al-Amen Technology</title>
        <meta name="description" content="Platform walkthroughs, product updates and event recaps from Al-Amen Technology." />
        <link rel="canonical" href={`${SITE_URL}/media`} />
        {videoJsonLd.map((entry, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(entry)}
          </script>
        ))}
      </Helmet>

      <PageHeader eyebrow={t('media.eyebrow')} title={t('media.title')} body={t('media.intro')} />

      <Container maxWidth="xl" sx={{ py: { xs: 5, md: 8 } }}>
        {error ? <Typography sx={{ color: 'text.secondary' }}>{t('media.empty')}</Typography> : null}
        {videos && videos.length === 0 && !error ? (
          <Typography sx={{ color: 'text.secondary' }}>{t('media.empty')}</Typography>
        ) : null}
        {videos && videos.length > 0 ? (
          <Grid container spacing={3}>
            {videos.map((video) => (
              <Grid key={video.id} item xs={12} sm={6} md={4}>
                <VideoCard video={video} />
              </Grid>
            ))}
          </Grid>
        ) : null}
      </Container>
    </Box>
  );
}
